import React from "react";
import styled from "@emotion/styled";
import { spacing } from "@atlas-int/tokens";
import { packageRegistry, type PackageEntry } from "../packageRegistry";
import PackageHeader from "../components/PackageHeader";
import ExportsList from "../components/ExportsList";
import SubExportTable from "../components/SubExportTable";
import CodeBlock from "../../atlas-ui/components/CodeBlock";

interface PackagePageProps {
  packageId: string;
  importExample: string;
  usageExamples?: Array<{ title: string; code: string }>;
}

const Section = styled.div`
  margin-bottom: ${spacing[10]};
`;

const SectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 ${spacing[4]} 0;
`;

const PackagePage: React.FC<PackagePageProps> = ({
  packageId,
  importExample,
  usageExamples,
}) => {
  const pkg = packageRegistry.find(
    (p) => p.id === packageId,
  ) as PackageEntry;

  return (
    <div>
      <PackageHeader
        name={pkg.name}
        description={pkg.description}
        dependencies={pkg.dependencies}
        peerDependencies={pkg.peerDependencies}
      />

      <Section>
        <SectionTitle>Import</SectionTitle>
        <CodeBlock code={importExample} />
      </Section>

      {pkg.subExports && pkg.subExports.length > 0 && (
        <SubExportTable
          packageName={pkg.name}
          subExports={pkg.subExports}
        />
      )}

      <Section>
        <SectionTitle>Exports</SectionTitle>
        <ExportsList categories={pkg.exportCategories} />
      </Section>

      {usageExamples && usageExamples.length > 0 && (
        <Section>
          <SectionTitle>Usage Examples</SectionTitle>
          {usageExamples.map((example) => (
            <div key={example.title} style={{ marginBottom: spacing[6] }}>
              <h4 style={{ margin: `0 0 ${spacing[2]} 0` }}>
                {example.title}
              </h4>
              <CodeBlock code={example.code} />
            </div>
          ))}
        </Section>
      )}
    </div>
  );
};

export default PackagePage;
